/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * https://community.shopify.com/c/shopify-design/product-pages-stay-on-the-product-page-after-adding-products-to/td-p/616440
 *
 * Modified
 *
 */

Shopify.AjaxifyCart = (function ($) {
  var _config = {
    addToCartBtnLabel: 'Add to cart',
    addingToCartBtnLabel: 'Adding...',
    addedToCartBtnLabel: 'Added!',
    soldOutBtnLabel: 'Sold Out',
    howLongTillBtnReturnsToNormal: 2000, // in milliseconds.
    cartCountSelector: '.cart-count',
    feedbackPosition: 'nextButton',

    addToCartBtnSelector: '[type="submit"]',
    addToCartBtnLabelSelector: '.product-form__submit-status',
    addToCartFormSelector: 'form[action="/cart/add"]',
    shopifyAjaxAddURL: '/cart/add.js',
    shopifyAjaxCartURL: '/cart.js',
  };

  // We need some feedback when adding an item to the cart.
  var _showFeedback = function (success, html, $addToCartForm) {
    $('.ajaxified-cart-feedback').remove();
    var feedback =
      '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
    $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
    $('.ajaxified-cart-feedback').slideDown();
  };
  var _setText = function ($button, label) {
    if ($button.children().length) {
      $button.children().each(function () {
        if ($.trim($(this).text()) !== '') {
          $(this).text(label);
        }
      });
    } else {
      $button.val(label).text(label);
    }
  };
  var _init = function () {
    $(_config.addToCartFormSelector).submit(function (e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
      var $addToCartBtnLabel = $addToCartForm.find(
        _config.addToCartBtnLabelSelector
      );

      _setText($addToCartBtnLabel, _config.addingToCartBtnLabel);
      $addToCartBtn.addClass('disabled').prop('disabled', true);
      // Add to cart.
      $.ajax({
        url: _config.shopifyAjaxAddURL,
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function (itemData) {
          // Re-enable add to cart button.
          $addToCartBtn.addClass('inverted');
          _setText($addToCartBtnLabel, _config.addedToCartBtnLabel);
          _showFeedback('success', 'Added to your order.', $addToCartForm);
          window.setTimeout(function () {
            $addToCartBtn
              .prop('disabled', false)
              .removeClass('disabled')
              .removeClass('inverted');
            _setText($addToCartBtnLabel, _config.addToCartBtnLabel);
            // close modal
            document.body.classList.remove('overflow-hidden');
            document
              .querySelectorAll('.quick-add-modal')
              .forEach((modal) => modal.removeAttribute('open'));
          }, _config.howLongTillBtnReturnsToNormal);

          // Update cart count
          $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
            if (
              _config.cartCountSelector &&
              $(_config.cartCountSelector).size()
            ) {
              var value = $(_config.cartCountSelector).html() || '0';
              $(_config.cartCountSelector)
                .html(value.replace(/[0-9]+/, cart.item_count))
                .removeClass('hidden-count');
            }
          });
        },
        error: function (XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          if (response.slice(0, 4) === 'All ') {
            _showFeedback(
              'error',
              response.replace('All 1 ', 'All '),
              $addToCartForm
            );
            $addToCartBtn.prop('disabled', false);
            _setText($addToCartBtnLabel, _config.soldOutBtnLabel);
            $addToCartBtn.prop('disabled', true);
          } else {
            _showFeedback(
              'error',
              '<i class="fa fa-warning"></i> ' + response,
              $addToCartForm
            );
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            _setText($addToCartBtnLabel, _config.addToCartBtnLabel);
          }
        },
      });
      return false;
    });
  };
  return {
    init: function (params) {
      // Configuration
      params = params || {};
      // Merging with defaults.
      $.extend(_config, params);
      // Action
      $(function () {
        _init();
      });
    },
    getConfig: function () {
      return _config;
    },
  };
})(jQuery);

$(document).ready(function () {
  window.addEventListener(
    'quick-add-modal-open',
    (e) => {
      console.log('I hear you');
      Shopify.AjaxifyCart.init();
    },
    false
  );
});
